'use client';

import { useState } from 'react';

import { ArrowRight, RefreshCw, Sparkles } from 'lucide-react';

import type { MarketingLocale } from '~/lib/marketing/site';

import { FINAL_CTA } from '../_lib/platform.content';
import { SchedulingModal } from './google-calendar-button';

const PATH_ICONS = [Sparkles, RefreshCw] as const;

/**
 * The two-path demo call to action (new venue vs switching). Each card opens
 * the scheduling modal in place, so every marketing page closes the same way.
 */
export function ScheduleDemoPaths({
  locale,
  buttonLabel = FINAL_CTA.button[locale],
}: {
  locale: MarketingLocale;
  buttonLabel?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="grid grid-cols-1 gap-4 text-start md:grid-cols-2">
        {FINAL_CTA.paths.map((path, index) => {
          const Icon = PATH_ICONS[index]!;

          return (
            <button
              key={path.title.en}
              type="button"
              onClick={() => setOpen(true)}
              className="group flex cursor-pointer items-start gap-5 rounded-[20px] border border-white/12 bg-white/[0.03] p-6 text-start transition-colors hover:border-white/30 hover:bg-white/[0.06] md:p-8"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px] bg-[#a9c8ff]/15 text-[#a9c8ff]">
                <Icon className="h-5 w-5" />
              </span>
              <span className="flex-1">
                <span className="block font-roboto text-[20px] font-medium text-white">
                  {path.title[locale]}
                </span>
                <span className="mt-1.5 block font-roboto text-[15px] leading-relaxed text-white/60">
                  {path.body[locale]}
                </span>
                <span className="mt-5 inline-flex items-center gap-2 font-roboto-mono text-[12px] uppercase tracking-wide text-white">
                  {buttonLabel}
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
                </span>
              </span>
            </button>
          );
        })}
      </div>
      <SchedulingModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
